import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Records from "@/pages/Records";
import Entry from "@/pages/Entry";
import TruckingEntry from "@/pages/TruckingEntry";
import TruckingRecords from "@/pages/TruckingRecords";
import SettingsPage from "@/pages/Settings";
import UsersPage from "@/pages/Users";
import WaybillsPage from "@/pages/Waybills";
import PendingApproval from "@/pages/PendingApproval";
import AppLayout from "@/components/AppLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

function PendingGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status === "approved") return <Navigate to="/inspection/entry" replace />;
  return <PendingApproval />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/pending" element={<PendingGate />} />

      {/* Inspection module */}
      <Route path="/inspection/entry" element={<ProtectedRoute><AppLayout><Entry /></AppLayout></ProtectedRoute>} />
      <Route path="/inspection/records" element={<ProtectedRoute><AppLayout><Records /></AppLayout></ProtectedRoute>} />
      <Route path="/inspection" element={<Navigate to="/inspection/entry" replace />} />
      {/* Backwards-compat redirects */}
      <Route path="/entry" element={<Navigate to="/inspection/entry" replace />} />
      <Route path="/records" element={<Navigate to="/inspection/records" replace />} />

      {/* Trucking module */}
      <Route path="/trucking/entry" element={<ProtectedRoute><AppLayout><TruckingEntry /></AppLayout></ProtectedRoute>} />
      <Route path="/trucking/records" element={<ProtectedRoute><AppLayout><TruckingRecords /></AppLayout></ProtectedRoute>} />
      <Route path="/trucking" element={<Navigate to="/trucking/entry" replace />} />

      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
      <Route path="/waybills" element={<ProtectedRoute><AppLayout><WaybillsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute requireAdmin><AppLayout><UsersPage /></AppLayout></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute requireAdmin><AppLayout><SettingsPage /></AppLayout></ProtectedRoute>} />

      <Route path="/" element={<Navigate to="/inspection/entry" replace />} />
      <Route path="*" element={<Navigate to="/inspection/entry" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
